module.exports = __webpack_public_path__ + "img/image4.f753ddd8.svg";